module.exports = __webpack_public_path__ + "media/images/new_home/shopping-icon-25c5df48dda2f4ae8875adfb787db998.png";